import connection from '@/api/connection'

// export const singIn = async ({ commit }, user) => {
//     tr
// }

export const getCountries = async ({ commit }) => {
  commit('setCountryIsLoading', true);
  let url = `/countries/selectable`;

  await connection.get(url)
    .then(res => {
      const countries = res.data.data;
      commit('setCountriesSelectable', countries);
      commit('setCountryIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setCountryIsLoading', false);
    });
}

export const loadCountries = async ({ commit }, query = null) => {
    let page = 1;
    let search = '';
    let perPage = 25;
    if(query !== null){
      page = query?.page || 1;
      search = query?.search || '';
      perPage = query?.perPage || 25;
    }

    commit('setCountryIsLoading', true);
    let url = `/countries`;
    if (search === '') {
      url = `${url}?page=${page}&perPage=${perPage}`;
    } else {
      url = `${url}?search=${search}&page=${page}&perPage=${perPage}`;
    }

    await connection.get(url)
      .then(res => {
        console.log(res);
        const countries = res.data.data;
        commit('setCountries', countries);
        const pagination = {
            totalItems: res.data.totalItems,  // total number of elements or items
            // per_page: res.data.per_page, // items per page
            currentPage: res.data.currentPage, // current page (it will be automatically updated when users clicks on some page number).
            totalPages: res.data.totalPages, // total pages in record

            perPage: res.data.perPage 
        }
        res.data.pagination = pagination;
        commit('setCountriesPaginated', res.data);
        commit('setCountryIsLoading', false);
      }).catch(err => {
        console.log('error', err);
        commit('setCountryIsLoading', false);
      });
}

export const countryById = async ({ commit }, id) => {
  commit('setCountryIsLoading', true);
  await connection.get(`/countries/${id}`)
    .then(res => {
      commit('setCountryDetail', res.data.data);
      commit('setCountryIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setCountryIsLoading', false);
    });
}

export const storeCountry = async ({ commit }, country) => {
  commit('setCountryIsCreating', true);
  await connection.post(`/countries/create`, country)
    .then(res => {
      commit('saveNewCountries', res.data);
      commit('setCountryIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setCountryIsCreating', false);
    });
}

export const updateCountry = async ({ commit }, country ) => {
  commit('setCountryIsUpdating', true);
  await connection.put(`/countries/${country.id}/update`, country)
    .then(res => {
      commit('saveUpdatedCountry', res.data);
      commit('setCountryIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setCountryIsUpdating', false);
    });
}

export const deleteCountry = async ({ commit }, country) => {
  commit('setCountryIsDeleting', true);
  await connection.delete(`/countries/${country.id}/delete`)
    .then(res => {
      commit('setDeleteCountry', res.data);
      commit('setCountryIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setCountryIsDeleting', false);
    });
}
